import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fractions, formatFraction, formatDifference } from 'utility/variables'; 
import NumberFormat from "react-number-format";

class ExistenciaRealModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    rowData: PropTypes.object,
    onConfirm: PropTypes.func.isRequired,
    error: PropTypes.string,
    conf_tipo_negocio: PropTypes.string,
  };

  state = {
    inputValue: '',
    selectedFraction: '1/1',
  };

  componentDidMount() {
   
  }

  handleInputChange = (e) => {
    this.setState({ inputValue: e.target.value });
  };

  handleFractionChange = (e) => {
    this.setState({ selectedFraction: e.target.value });
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.handleConfirm();
    }
  };

  handleConfirm = () => {
    const { inputValue, selectedFraction } = this.state;
    const value = parseFloat(inputValue);
    const fractionObject = fractions.find((f) => f.fraction === selectedFraction);
    const fractionValue = fractionObject ? parseFloat(fractionObject.value) : 0;

    if (inputValue === '' || isNaN(value)) {
      this.props.onConfirm(null, 'Debe ingresar un valor numérico');
      return;
    }

    const totalValue = value + (selectedFraction !== "1/1" ? fractionValue : 0);
    this.props.onConfirm(totalValue);
    this.setState({ inputValue: '', selectedFraction: '1/1' });
  };

  render() {
    const { show, onHide, rowData, error, conf_tipo_negocio } = this.props;
    const { inputValue, selectedFraction } = this.state;

    if (!show) return null;

    console.log('conf_tipo_negocio in render:', conf_tipo_negocio);

    const productoNombre = rowData && rowData.producto 
      ? rowData.producto.nombre 
      : "Sin nombre";
    const existenciaSistema = rowData && rowData.inventario 
      ? conf_tipo_negocio === "Telas"
        ? formatFraction(rowData.inventario)
        : rowData.inventario
      : 0;

    const parsedInput = parseFloat(inputValue);
    const fractionObject = fractions.find((f) => f.fraction === selectedFraction);
    const fractionValue = fractionObject ? parseFloat(fractionObject.value) : 0;
    const diferencia = !isNaN(parsedInput)
      ? conf_tipo_negocio === "Telas"
        ? formatDifference(parsedInput + (selectedFraction !== "1/1" ? fractionValue : 0) - rowData.inventario)
        : parsedInput + (selectedFraction !== "1/1" ? fractionValue : 0) - rowData.inventario
      : 0;

    return (
      <div className="modal-backdrop" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}>
        <div className="modal-content" style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          minWidth: '400px',
          maxWidth: '600px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ marginBottom: '15px' }}>
            Asignar existencia real para {productoNombre}
          </h3>
          <p style={{ marginBottom: '10px', color: '#666' }}>
            Existencia en sistema: {existenciaSistema}
          </p>
          <p style={{ marginBottom: '10px', color: '#666' }}>
            Diferencia: {typeof diferencia === 'number' ? diferencia.toFixed(2) : diferencia}
          </p>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
            <NumberFormat
              className="form-control"
              style={{ flex: 1 }}
              value={inputValue}
              decimalScale={
                rowData && rowData.producto && rowData.producto.a_granel ? 3 : 0
              }
              // allowNegative={false}
              allowLeadingZeros={false}
              onValueChange={({ value }) => {
                // Solo permite vacío o números positivos con o sin decimales según a_granel
                this.setState({ inputValue: value });
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  this.handleConfirm();
                }
              }}
              autoFocus
            />
            {conf_tipo_negocio === "Telas" && rowData && rowData.producto && rowData.producto.a_granel && (
              <select
                value={selectedFraction}
                onChange={this.handleFractionChange}
                className="form-control"
                style={{ flex: 1 }}
              >
                <option value="1/1">Unidad</option>
                {fractions.map((f) => (
                  <option key={f.fraction} value={f.fraction}>
                    {f.fraction}
                  </option>
                ))}
              </select>
            )}
          </div>
          
          {error && (
            <div className="text-danger mb-2" style={{ fontSize: '0.9em' }}>
              {error}
            </div>
          )}
          
          <div className="modal-actions" style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px'
          }}>
            <button
              onClick={() => {
                onHide(); 
                this.setState({ inputValue: '', selectedFraction: '1/1' }); 
              }}
              className="btn btn-secondary"
            >
              Cancelar
            </button>
            <button
              onClick={this.handleConfirm}
              className="btn btn-primary"
            >
              Asignar
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ExistenciaRealModal;